import Image from "next/image";
import Router from "next/router";

import PageTemplate from "@component/dashboard/credit-score/page_template";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";

import coinPlant from "./assets/coin_plant.svg";

interface NoOffersPageProps extends PageRegistration {}

export default function NoOffersPage({
  configFlow,
  Button,
}: NoOffersPageProps) {
  configFlow.button(
    <Button
      onClick={(e) => {
        e.preventDefault();
        Router.replace("/dashboard/store/select-plan");
      }}
    >
      See credit builder plans
    </Button>
  );

  return (
    <PageTemplate
      title="Unfortunately there are no offers available for you at this time"
      contentFor={{
        aboveTitle: (
          <div className="text-center">
            <Image src={coinPlant} className="mt-6 mb-3" />
          </div>
        ),
      }}
    >
      Fortunately, we have credit building plans that can help you achieve your
      borrowing goals.
    </PageTemplate>
  );
}
